import { Button } from "components/ui/button";
import { ArrowRight } from "lucide-react";

const URLType = ({ setUrlType }) => {
  return (
    <div className="p-6">
      <div className="space-y-5">
        <Button
          type="button"
          variant="outline"
          className="w-full h-auto flex items-center justify-between rounded-lg border-border bg-background transition-colors px-9 py-8 group hover:border-muted-foreground hover:bg-muted [&_svg]:size-6"
          onClick={() => setUrlType("single")}
        >
          <div className="text-left">
            <div className="text-base font-semibold text-foreground mb-2">
              Add a Webpage
            </div>
            <div className="text-sm text-muted-foreground font-normal">
              Add <span className="font-semibold">one</span> page from website
            </div>
          </div>
          <ArrowRight className="h-6 w-6 text-foreground hidden group-hover:block" />
        </Button>
        <Button
          type="button"
          variant="outline"
          className="w-full h-auto flex items-center justify-between rounded-lg border-border bg-background transition-colors px-9 py-8 group hover:border-muted-foreground hover:bg-muted [&_svg]:size-6"
          onClick={() => setUrlType("multi")}
        >
          <div className="text-left">
            <div className="text-base font-semibold text-foreground mb-2">
              Add a Website
            </div>
            <div className="text-sm text-muted-foreground font-normal">
              Add <span className="font-semibold">up to 10</span> pages from a
              website
            </div>
          </div>
          <ArrowRight className="h-6 w-6 text-foreground hidden group-hover:block" />
        </Button>
      </div>
    </div>
  );
};

export default URLType;
